import React from 'react';
import { Button } from 'antd';

interface ButtonLinkProps {
  title: string;
  icon: React.ReactElement;
  onClick: Function;
  className?: string;
  disabled?: boolean;
}

const ButtonLink = ({ title, icon, onClick, className, disabled }: ButtonLinkProps) => {
  return (
    <Button className={`button ${className || 'button-transparent'}`} disabled={disabled} onClick={() => onClick()}>
      {icon}
      {title}
    </Button>
  );
};

export default ButtonLink;
